<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_51",
      next: "P_53",
      topic: "Estás en: Taller Conoce el Crédito / ¿Qué aprendí en esta lección?",
      progress: false
    };
  },
  methods: {
    finish() {
      this.progress = true;
      eventBus.$emit("finish");
      setTimeout(function(){
        window.location.href = 'https://www.bbva.mx/educacion-financiera/talleres-en-linea.html'
      }, 1000)
    }
  }
};
</script>

<template lang="pug">
  v-app(style='background: #FFFFFF !important;')
    v-container(fluid, grid-list-xl)
      v-content
        v-layout(row, justify-center)
          v-flex(xs12, sm12, md10, lg9)
            v-card(flat, text-xs-center)
            breadcrumb(:back='last')
              v-card-text.label16tt.withDivider
                | TALLER ¿QUÉ ES CRÉDITO?
              .titulo36Book.pa-0.ma-0.px-5
                b Descubre más oportunidades ...
            v-layout(row, wrap, justify-start, py-4)
              v-flex.ma-0.pa-0(xs12, md5)
                v-card.pa-4(flat, text-xs-start, height='100%', color='accent')
                  v-card-text.parrafoDestacado18.py-3.px-4(style="color:white")
                    b ¿Disfrutaste el recorrido? Ahora que conoces los componentes básicos de un Crédito, 
                    b te invitamos a complementar tu camino de aprendizaje con:
                  v-card-text.parrafoDestacado18.py-3.px-4(style="color:white")
                    ul
                      li
                        a.parrafo14Book(href="https://www.bbva.mx/educacion-financiera/mejor-credito-hipotecario.html"  target="_blank" style="color:white") Para un mejor crédito hipotecario
                      li
                        a.parrafo14Book(href="https://www.bbva.mx/educacion-financiera/como-aprovechar-una-tarjeta-de-credito-.html"  target="_blank" style="color:white") Finánciate con tu tarjeta de crédito
                      li
                        a.parrafo14Book(href="https://www.bbva.mx/educacion-financiera/como-hacer-un-plan-de-vida.html"  target="_blank" style="color:white") ¿Cómo hacer un plan de vida?
                  
              v-flex.ma-0.pa-0(xs12, md7)
                v-card.px-4(flat, height='100%')
                  v-card-text.parrafoDestacado18.py-0.pt-4
                    v-layout(row, wrap, justify-start, py-4)
                      v-flex.ma-0.pa-0(xs12, md3)
                        img(src="@/assets/bbva_logo.png" height=128 width=128)
                      v-flex.ma-0.pa-0.pt-4.pl-4(xs12, md9)
                        b ¡Revisa todos los 
                        a(href="https://www.bbva.mx/educacion-financiera/creditos/ventajas-al-contratar-un-credito-de-nomina-al-iniciar-el-ano.html"  target="_blank" style='color:#2A86CA') productos
                        b  que BBVA tiene para ti! 
                  v-card-text.parrafoDestacado18.py-0.pt-4
                    v-layout(row, wrap, justify-start, py-4)
                      v-flex.ma-0.pa-0(xs12, md3)
                        img(src="@/assets/TCC-L9-Pagina7 A_2.png"  height=128 width=128)
                      v-flex.ma-0.pa-0.pt-4.pl-4(xs12, md9)
                        b ¿Quieres reforzar tus conocimientos?
                        br
                        | Complementa tu aprendizaje en el 
                        a(href="https://www.bbvaeducacionfinanciera.mx/"  target="_blank" style='color:#2A86CA') Blog de Educación Financiera  
                  v-card-text.parrafoDestacado18.py-0v-layout(row, justify-center)
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button', color='primary' @click.prevent="finish('NoPayload')")
                | Finalizar
            l-progress(:value='this.$parent.currentPage')

</template>


